import React from 'react'
import styled, { keyframes } from 'styled-components'

interface ShimmerProps extends React.HTMLAttributes<HTMLDivElement> {
  width?: string | number
  height?: string | number
  borderRadius?: string | number
  backgroundColor?: string
}

interface StyledProps {
  $width: string | number
  $height: string | number
  $borderRadius: string | number
  $backgroundColor?: string
}

const shimmerAnimation = keyframes`
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
`

const ShimmerWrapper = styled.div<StyledProps>`
  position: relative;
  overflow: hidden;
  background-color: ${({ theme, $backgroundColor }) =>
    $backgroundColor ?? `${theme.colors.neutralGray}`};
  background-image: linear-gradient(135deg, rgba(0, 0, 0, 0.025) 0%, rgba(255, 255, 255, 0) 100%);
  width: ${({ $width }) => (typeof $width === 'number' ? `${$width}px` : $width)};
  height: ${({ $height }) => (typeof $height === 'number' ? `${$height}px` : $height)};
  border-radius: ${({ $borderRadius }) =>
    typeof $borderRadius === 'number' ? `${$borderRadius}px` : $borderRadius};

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 80%;
    background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0) 0%,
      rgba(0, 0, 0, 0.05) 15%,
      rgba(255, 255, 255, 0.7) 32%,
      rgba(255, 255, 255, 0.98) 50%,
      rgba(255, 255, 255, 0.7) 68%,
      rgba(0, 0, 0, 0.05) 85%,
      rgba(255, 255, 255, 0) 100%
    );
    background-size: 280% 100%;
    filter: blur(4px);
    opacity: 0.95;
    animation: ${shimmerAnimation} 1.1s infinite;
  }
`

export const Shimmer: React.FC<ShimmerProps> = ({
  width = '100%',
  height = '1rem',
  borderRadius = '0.5rem',
  backgroundColor,
  ...rest
}) => {
  return (
    <ShimmerWrapper
      $width={width}
      $height={height}
      $borderRadius={borderRadius}
      $backgroundColor={backgroundColor}
      {...rest}
    />
  )
}

export default Shimmer
